export enum SidebarMenuItemLabel {
  overview = "Overview",
  examPrep = "Exam Prep",
  assignments = "Assignments",
  askAmelia = "Ask Amelia"
}

export type SidebarMenuItem = keyof typeof SidebarMenuItemLabel;

export type SidebarMenuItemState = {
  [key in SidebarMenuItem]: boolean;
};
